import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './TablaMonitoreo.scss'
import IconInput from '../../atoms/IconInput/IconInput';
import searchIcon from '../../../assets/icons/search.svg'
const TablaMonitoreo = ({data,statusBody}) => {
    const [globalFilter, setGlobalFilter] = useState(null);
   
    
   
    return (
        <div className="TablaMonitoreo">
            <div className="datatable-crud-demo">
                <div className="card">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <IconInput
                            type="search"
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Buscar..."
                            icon={searchIcon}
                        />
                    </span>
                    <DataTable
                        value={data}
                        globalFilter={globalFilter}
                        scrollable 
                        scrollHeight="calc(100vh - 64vh )"
                        // paginator
                        // rows={10}
                        // rowsPerPageOptions={[5, 10, 20]}
                    >
                        <Column field="STATUS" header="Estatus" body={statusBody} sortable />
                        <Column field="ID" header="Id BITACORA" sortable body={(rowData) => <td data-label="ruta">{rowData.ID}</td>}/>
                        <Column field="RUTA" header="Ruta" sortable body={(rowData) => <td data-label="ruta"> <div className="contenedorText">{rowData.RUTA}</div></td>}/>
                        <Column field="HORARIO" header="Horario" sortable body={(rowData) => <td data-label="horario" className='horario'>{rowData.HORARIO}</td>}/>
                        <Column field="OPERADOR" header="Operador" sortable  body={(rowData) => <td data-label="operador"> <div className="contenedorText">{rowData.OPERADOR?rowData.OPERADOR +" - "+rowData.TURNO +" - "+rowData.TIPO:!rowData.OPERADOR?rowData.PROVEEDOR_NOMBRE+" - "+rowData.TURNO+" - "+rowData.TIPO:"Sin asignar"}</div></td>}/>
                        <Column field="PROVEEDOR_TELEFONO" header="Celular" sortable body={(rowData) => <td data-label="celular">{rowData.PROVEEDOR_TELEFONO?rowData.PROVEEDOR_TELEFONO:rowData.PROVEEDOR_TELEFONO}</td>}/>
                    </DataTable>
                </div>
            </div>
        </div>
    )
}
export default TablaMonitoreo